import * as React from 'react'; 
import {
  Modal,
  getTheme,
  mergeStyleSets,
  FontWeights,
  Stack
} from '@fluentui/react';
import { useDocuments } from "../redux/hooks/useDocuments";
import { useSpinner } from "../theme/styles/SpinnerStyle"; 
import spinner from '../assets/spinner.png';
import "../scss/spinner.scss"; 

const SpinnerModal = () => {
  const { filteredDocuments } = useDocuments();
  const enableSpinner = filteredDocuments.enableSpinner;
  const spinnerText = filteredDocuments.spinnerText;
  const styleTheme = useSpinner();
  return (
    <div>
      <Modal 
       styles={styleTheme.TextStyle}
        isOpen={enableSpinner}
        containerClassName={contentStyles.container}
        dragOptions={false} >
  
        <div style={{ paddingTop: "60px" }}>
        <img className='spinner' src={spinner} style={{ width: '30px', height: '30px', padding:'5px'}} /> 
        <br />
        <Stack>
        <Stack.Item align="center">
          <span style={{ color:theme.palette.themePrimary}}>{spinnerText}</span>
        </Stack.Item>
        </Stack> 
      </div> 
      </Modal>
    </div>
  );
};
 
const theme = getTheme();
const contentStyles = mergeStyleSets({
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch',
    color:"red"
  },
  header: [
    theme.fonts.xLargePlus,
    {
      flex: '1 1 auto',
      borderTop: `4px solid ${theme.palette.themePrimary}`,
      display: 'flex',
      alignItems: 'center',
      fontWeight: FontWeights.semibold,
    },
  ],
  body: {
    flex: '4 4 auto',
    padding: '0 24px 24px 24px',
    overflowY: 'hidden',
    selectors: {
      p: { margin: '14px 0' },
      'p:first-child': { marginTop: 0 },
      'p:last-child': { marginBottom: 0 },
    },
  },
}); 

export default SpinnerModal;